export const productTypes = [
    { value: 'i', label: 'Alleen internet' },
    { value: 'it', label: 'Internet en tv' },
    { value: 'ipt', label: 'Internet, tv en bellen' },
];

export const deliveryTimes = [
    { value: null, label: 'Maakt niet uit' },
    { value: '14', label: 'Binnen 2 weken' },
    { value: '28', label: 'Binnen 4 weken' },
];

export const sortingOptions = [
    { value: 'price', label: 'Laagste prijs incl. korting' },
    { value: 'price_monthly', label: 'Laagste vaste prijs' },
    { value: 'speed', label: 'Downloadsnelheid' },
];

// TODO: Make these dynamic:
export const providers = [
    {
        label: 'Budget Alles-in-1',
        value: 'nlex',
    },
    {
        label: 'Caiway',
        value: 'caiway',
    },
    {
        label: 'Delta',
        value: 'delta',
    },
    {
        label: 'Jonaz',
        value: 'jonaz',
    },
    {
        label: 'KPN',
        value: 'kpn',
    },
    {
        label: 'Odido',
        value: 't-mobile',
    },
    {
        label: 'Online.nl',
        value: 'onlinenl',
    },
    {
        label: 'Solcon',
        value: 'solcon',
    },
    {
        label: 'Youfone',
        value: 'youfone',
    },
    {
        label: 'Ziggo',
        value: 'ziggo',
    },
];

export const combiProvidersEnergy = [
    {
        label: 'Budget Energie',
        slug: 'budget-energie',
        logo: 'https://internetvergelijker.keuze.nl/logo/tv/npo1',
    },
];


export const contractDurations = [
    {
        label: '1 jaar',
        value: '12',
    },
    {
        label: '2 jaar',
        value: '24',
    },
];

export const combiProvidersMobile = [
    {
        label: 'Ben',
        slug: 'ben',
        logo: 'https://internetvergelijker.keuze.nl/logo/tv/npo1',
    },
    {
        label: 'Budget Mobiel',
        slug: 'budget-mobiel',
        logo: 'https://internetvergelijker.keuze.nl/logo/tv/npo1',
    },
    {
        label: 'hollandsnieuwe',
        slug: 'hollandsnieuwe',
        logo: 'https://internetvergelijker.keuze.nl/logo/tv/npo1',
    }, {
        label: 'KPN',
        slug: 'kpn',
        logo: 'https://internetvergelijker.keuze.nl/logo/tv/npo1',
    },
    {
        label: 'Odido',
        slug: 't-mobile',
        logo: 'https://internetvergelijker.keuze.nl/logo/tv/npo1',
    },
    {
        label: 'Simyo',
        slug: 'simyo',
        logo: 'https://internetvergelijker.keuze.nl/logo/tv/npo1',
    },
    {
        label: 'Tele2',
        slug: 'tele2',
        logo: 'https://internetvergelijker.keuze.nl/logo/tv/npo1',
    },
    {
        label: 'Vodafone',
        slug: 'vodafone',
        logo: 'https://internetvergelijker.keuze.nl/logo/tv/npo1',
    },
];
